var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39886 3.23223C2.8677 2.76339 3.50358 2.5 4.16663 2.5H9.99996C10.663 2.5 11.2989 2.76339 11.7677 3.23223C12.2366 3.70107 12.5 4.33696 12.5 5V6.66667C12.5 7.1269 12.1269 7.5 11.6666 7.5C11.2064 7.5 10.8333 7.1269 10.8333 6.66667V5C10.8333 4.77899 10.7455 4.56702 10.5892 4.41074C10.4329 4.25446 10.221 4.16667 9.99996 4.16667H4.16663C3.94561 4.16667 3.73365 4.25446 3.57737 4.41074C3.42109 4.56702 3.33329 4.77899 3.33329 5V15C3.33329 15.221 3.42109 15.433 3.57737 15.5893C3.73365 15.7455 3.94561 15.8333 4.16663 15.8333H9.99996C10.221 15.8333 10.4329 15.7455 10.5892 15.5893C10.7455 15.433 10.8333 15.221 10.8333 15V13.3333C10.8333 12.8731 11.2064 12.5 11.6666 12.5C12.1269 12.5 12.5 12.8731 12.5 13.3333V15C12.5 15.663 12.2366 16.2989 11.7677 16.7678C11.2989 17.2366 10.663 17.5 9.99996 17.5H4.16663C3.50358 17.5 2.8677 17.2366 2.39886 16.7678C1.93002 16.2989 1.66663 15.663 1.66663 15V5C1.66663 4.33696 1.93002 3.70107 2.39886 3.23223ZM14.4107 6.91074C14.7361 6.58531 15.2638 6.58531 15.5892 6.91074L18.0892 9.41074C18.4147 9.73618 18.4147 10.2638 18.0892 10.5893L15.5892 13.0893C15.2638 13.4147 14.7361 13.4147 14.4107 13.0893C14.0853 12.7638 14.0853 12.2362 14.4107 11.9107L15.4881 10.8333H5.83329C5.37306 10.8333 4.99996 10.4602 4.99996 10C4.99996 9.53976 5.37306 9.16667 5.83329 9.16667H15.4881L14.4107 8.08926C14.0853 7.76382 14.0853 7.23618 14.4107 6.91074Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e04640ba6829c006c23b064d89c9ab8c.svg";
export { ForwardRef as ReactComponent };